import i18n from './i18n';
import smbUtils from './smbUtils';
import langUtils from './langUtils';
import {multipleSubscriptionsUtils} from './solutionUtils';

const prefix =
  smbUtils.getUrl() + langUtils.convertToFrontendLangUrl(i18n.language);
const prefixNonLang = smbUtils.getUrl();
const locale = langUtils.convertToFrontendLangUrl(i18n.language).replace(/^\//, '');
const stagePrefix =
  smbUtils.getUrl('stage') + langUtils.convertToFrontendLangUrl(i18n.language);

const utils = {
  getPfHomeUrl: (campaign = '') =>
    `${prefix}?utm_source=smb&utm_campaign=${campaign}`,
  getDocumentCenterUrl: (campaign = '') =>
    `${prefixNonLang}/document-center/${smbUtils.documentCenterLanguage()}/?utm_source=smb&utm_campaign=${campaign}`,
  getFAQUrl: (campaign = '', type = '') =>
    `${prefix}/business/faq?defaultType=${type}&utm_source=smb&utm_campaign=${campaign}`,
  getTermsUrl: (campaign = '') =>
    `${prefix}/business/terms?utm_source=smb&utm_campaign=${campaign}`,
  getPrivacyUrl: (campaign = '') =>
    `${prefix}/business/privacy?utm_source=smb&utm_campaign=${campaign}`,
  getAboutUsUrl: (campaign = '') =>
    `${prefix}/business/info/aboutus?utm_source=smb&utm_campaign=${campaign}`,
  getContactUsUrl: (campaign = '', type = '') =>
    `${prefix}/business/contact-us${
      type ? '/' + type : ''
    }?utm_source=smb&utm_campaign=${campaign}`,
  getDemoStoreUrl: (campaign = '') =>
    `${stagePrefix}/business/showcase/online-service?utm_source=smb&utm_campaign=${campaign}`,
  getEyewearDemoStoreUrl: (campaign = '') =>
    `${stagePrefix}/business/showcase/online-service/eye-wear?utm_source=smb&utm_campaign=${campaign}`,
  getPlanPriceUrl: (
    campaign = 'compare-plan',
    customerId = '',
    solutionType = 'MAKEUP'
  ) => {
    return `${prefix}/business/solutions/online-service/${
      multipleSubscriptionsUtils.getSolutionTypeInfo(solutionType).comPage
    }/plan?utm_source=smb&utm_campaign=${campaign}&utm_content=${customerId}#switchBtnAnchor`;
  },
  getPartnerUrl: (campaign = '') =>
    `${prefix}/business/partner/sign-up?utm_source=partner&utm_campaign=${campaign}`,
  getTosUrl: () =>
    `${prefixNonLang}/prog/ap/business/forward?type=terms&locale=${locale}`,
  getSkincareProTosUrl: () =>
    `${prefixNonLang}/prog/ap/beauty-circle/forward.jsp?type=terms&locale=${locale}&app=scp`,
  getPpUrl: () =>
    `${prefixNonLang}/prog/ap/business/forward?type=privacy-policy&locale=${locale}`,
  getDocumentCenterPlatformSupportUrl: (platform = '') =>
    `${prefix}/document-center/${smbUtils.documentCenterLanguage()}/${platform}`,
};

export default utils;
